import ContactForm from "../ContactBody/contactbody"
import Header from "../Home/Screens/Header"
import ContentFooter from "../Services/Screens/ContentFooter"

const Contact = () => {

    return (


        <>
            <Header />
            <ContactForm />
            <ContentFooter />

        </>
    )
}


export default Contact